import languageService from '../../services/ClassenService/modules/languageService';
import selectionService from "../../services/ClassenService/modules/selectionService";

const state = {
  languages: [],
  languagesFacets: [],
};

const getters = {
  getLanguages() {
    return state.languages;
  },
};

const mutations = {
  SET_LANGUAGES: (state, languages) => {
    state.languages = languages
  }
};

const actions = {
  getLanguages: (context) => {
    if (context.state.languages.length === 0) {
      context.commit('SET_LANGUAGES', ["loading"]);
      languageService.getLanguages().then((response) => {
        context.commit('SET_LANGUAGES', response.data)
      });
    }
    return context.state.languages
  },

  async getLanguagesFresh() {
    const response = await languageService.getLanguages();
    return response.data
  },

  forceReloadLanguages: (context) => {
    languageService.getLanguages().then((response) => {
      context.commit('SET_LANGUAGES', response.data);
    });
  },

  getLanguage: ({commit}, languageId) => new Promise((resolve, reject) => {
    languageService.getLanguage(languageId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  updateLanguage: ({commit}, languageId, languageData) => new Promise((resolve, reject) => {
    languageService.updateLanguage(languageId, languageData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  deleteLanguage: ({commit}, languageId) => new Promise((resolve, reject) => {
    languageService.deleteLanguage(languageId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  addLanguage: ({commit}, languageData) => new Promise((resolve, reject) => {
    languageService.addLanguage(languageData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  activateLanguage: ({commit}, languageData) => new Promise((resolve, reject) => {
    languageService.activateLanguage(languageData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

};

export default {
  state, mutations, getters, actions,
};
